export default "__VITE_ASSET__01f00c0c__"